import { render, staticRenderFns } from "./WorkingUnsolvedExportReturn.vue?vue&type=template&id=64c9d210"
import script from "./WorkingUnsolvedExportReturn.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolvedExportReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c9d210')) {
      api.createRecord('64c9d210', component.options)
    } else {
      api.reload('64c9d210', component.options)
    }
    module.hot.accept("./WorkingUnsolvedExportReturn.vue?vue&type=template&id=64c9d210", function () {
      api.rerender('64c9d210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolvedExportReturn.vue"
export default component.exports